import { render, staticRenderFns } from "./LogDetailView.vue?vue&type=template&id=a221f184"
import script from "./LogDetailView.vue?vue&type=script&lang=js"
export * from "./LogDetailView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports